export default __webpack_public_path__ + "static/media/notification-bell-gray.296b391a.svg";